import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';
import { makeSelectCabinet } from 'containers/Configurator/selectors/furniture';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { createCabinetPiecesList } from 'lib/modelBuilder/utils/cabinetPiecesList';
import { CabinetPieces } from 'lib/modelBuilder/Data';

/**
 * Direct selector to the piecesList state domain
 */

const selectPiecesListDomain = (state: ApplicationRootState) =>
  state.piecesList || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by PiecesList
 */

// export const makeSelectIsVisiblePiecesList = () =>
//   createSelector(
//     selectPiecesListDomain,
//     substate => substate.visible,
//   );

const makeSelectListPieces = () =>
  createSelector(
    selectPiecesListDomain,
    makeSelectCabinet(),
    (substate, cabinet: Cabinet | null): CabinetPieces | null => {
      if (cabinet)
        // Call method to get the list of pieces from modelBuilder library
        return createCabinetPiecesList(cabinet);
      return null;
    },
  );

export { selectPiecesListDomain, makeSelectListPieces };
